import { useTranslation } from "react-i18next";

export type TaxRefundMethod = "bank_transfer" | "cash_agent" | "agent_company";

/** What the shop can offer (tax-service settings) — Stripe (card refund) is phase 2 (R18). */
export function offeredRefundMethods(methods: readonly string[]): TaxRefundMethod[] {
  return methods.filter(
    (m): m is TaxRefundMethod =>
      m === "bank_transfer" || m === "cash_agent" || m === "agent_company",
  );
}

/**
 * 4) リファンド方式 (design/05 §3.3): how the shop pays the tax back after customs (振込 /
 * 現金(代理) / 代理店) and the buyer's e-mail for the purchase record + the 90-day notice.
 * Required before 「免税で会計へ進む」.
 */
export function RefundMethodForm({
  methods,
  value,
  onChange,
  email,
  onEmail,
}: {
  methods: TaxRefundMethod[];
  value: TaxRefundMethod | null;
  onChange: (method: TaxRefundMethod) => void;
  email: string;
  onEmail: (email: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-3">
      <fieldset>
        <legend className="mb-1 font-medium">{t("taxfree.refund_method")}</legend>
        <p className="mb-2 text-sm text-muted-foreground">{t("taxfree.refund_method_help")}</p>
        <div
          className="grid grid-cols-3 gap-2"
          role="radiogroup"
          aria-label={t("taxfree.refund_method")}
        >
          {methods.map((method) => (
            <button
              key={method}
              type="button"
              role="radio"
              aria-checked={value === method}
              onClick={() => onChange(method)}
              className="min-h-pos-touch rounded-md border px-3 text-lg aria-checked:border-primary aria-checked:bg-primary aria-checked:text-primary-foreground"
            >
              {t(`taxfree.refund_${method}`)}
            </button>
          ))}
        </div>
        {methods.length === 0 ? (
          <p role="alert" className="text-pos-problem">
            {t("taxfree.refund_none")}
          </p>
        ) : null}
      </fieldset>
      <label className="flex flex-col gap-1">
        <span className="font-medium">{t("taxfree.buyer_email")}</span>
        <span className="text-sm text-muted-foreground">{t("taxfree.buyer_email_help")}</span>
        <input
          type="email"
          value={email}
          onChange={(e) => onEmail(e.target.value.trim())}
          autoComplete="off"
          inputMode="email"
          className="min-h-pos-touch rounded-md border px-3 text-lg"
        />
      </label>
    </div>
  );
}
